import { useDataSubmit, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'task',
    viewPath: props.viewPath,
  })

  let task_tag = useDataValue({
    context: 'task_tag',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({
      type: 'delete_task_tag',
      id: task_tag.id,
    })
  }
}
